<template>
    <footer class="sitefooter">
        <div class="sitefooter__container">
            <LogoBullet></LogoBullet>
            <nav class="sitefooter__links">
                <a @click.prevent="openInfosModal('cookies')">cookies</a>
                <a @click.prevent="openInfosModal('conditions')">conditions</a>
                <a @click.prevent="openInfosModal('privacy')">vie privée</a>
                <a @click.prevent="openInfosModal('contact')">contact</a>
                <a @click.prevent="openInfosModal('faq')">FAQ</a>
            </nav>
            <div class="sitefooter__copyright">
                <strong>{{year}}© Testachats</strong> <br>
                Association des consommateurs Testachats SC <br>
                Rue de Hollande 13, 1060 Bruxelles
            </div>
        </div>
    </footer>
</template>

<script>
import LogoBullet from "../LogoBullet";
import InfosModal from "../modals/InfosModal";
import {DateTime} from "luxon";

export default {
    name: "SiteFooter",
    components:{LogoBullet},
    data(){
        return{
            year: DateTime.now().toFormat('yyyy')
        }
    },
    methods: {
        openInfosModal(tab) {
            this.$buefy.modal.open({
                component: InfosModal,
                props: {
                    activeTab: tab
                }
            })
            dataLayer.push({
                event:'openModal',
                step:this.$store.get('general_data/current_step'),
                eventSource: 'footer',
                modalTab:tab,
            })
        }
    }
}
</script>

<style lang="scss" scoped></style>
